module.exports = __webpack_public_path__ + "static/media/app_logo_fork.74f12c00.svg";